function Loader() {
  return (
    <div className="loader" role="status" aria-label="Loading">
      <div className="pokeball-loader">
        <span className="pokeball-loader__half pokeball-loader__half--top" />
        <span className="pokeball-loader__band" />
        <span className="pokeball-loader__half pokeball-loader__half--bottom" />
        <span className="pokeball-loader__btn" />
      </div>
    </div>
  );
}

export default Loader;
